import { RadnoVrijemeGpsEvdInterface } from "./RadnoVrijemeGpsEvd.resources";

export const RadnoVrijemeGpsEvdResourceEN: RadnoVrijemeGpsEvdInterface = {
  title: "Working time evidence with GPS location",
  description:
    "Please select the period in which working time evidence with GPS location is located.",
  addButton: "Add",
  gpsPermissionMessage:
    "Please allow access to GPS location so you can record working time. GPS location is required for working time tracking.",
  gpsError: "Error retrieving GPS location. Please check permissions and try again.",
  gpsNotAvailable: "GPS location is not available. Please enable GPS location access.",
  inputFields: {
    startDate: {
      label: "Start date",
    },
    endDate: {
      label: "End date",
    },
    actionType: {
      error: "Please select action type.",
      label: "Action type",
      name: "actionType",
      placeholder: "Select action type",
    },
  },
  errors: {
    errorLoading:
      "An error occurred while loading working time evidence with GPS location. Please contact the administrator.",
    errorCreating:
      "An error occurred while creating working time evidence with GPS location. Please contact the administrator.",
    errorDeleting:
      "An error occurred while deleting working time evidence with GPS location. Please contact the administrator.",
    errorMissingFields:
      "Please select action type and allow GPS location access.",
  },
  actionTypes: {
    placeholder: "Select action type",
    startWork: "Start work",
    takeBreak: "Take break",
    endBreak: "End break",
    endWorkDay: "End work day",
  },
  successModal: {
    title: "Successfully added to database",
    body: "Working time entry with GPS location has been successfully saved.",
    buttonOk: "OK",
  },
  timestampLabel: "Time:",
  locationLabel: "Location:",
  noLocation: "Location not available",
};

